import {Button, Tag} from 'platform/components';
import {HStack, Show} from 'platform/foundation';

import {isNil} from 'ramda';

import {CustomerMessageResponseBody} from '@dms/api/core';
import {i18n} from '@dms/i18n';

import {Nullish} from 'shared/web';

import {ThreadReadState} from '../types/ThreadReadState';

interface ThreadReadStateControlsProps {
  message: CustomerMessageResponseBody;
  readState: ThreadReadState | Nullish;
}

/** "New" marker and the manual read toggle of an incoming message. */
export function ThreadReadStateControls(props: ThreadReadStateControlsProps) {
  const readState = props.readState;

  if (isNil(readState) || props.message.direction !== 'INCOMING') {
    return null;
  }

  const isNew = readState.newMessageIds.includes(props.message.id);
  // One set of controls per message, so the message id keeps the test ids unique in the thread.
  const testId = `communicationThread-message-${props.message.id}`;

  return (
    <HStack spacing={2} align="center">
      <Show when={isNew}>
        <Tag
          label={i18n.t('general.labels.new')}
          colorScheme="red"
          size="small"
          data-testid={`${testId}-newMarker`}
        />
      </Show>
      {props.message.isUnread ? (
        <Button
          variant="ghostLink"
          size="small"
          leftIcon="communication/mark_email_read"
          title={i18n.t('general.actions.markAsRead')}
          onClick={() => readState.onMarkRead(props.message)}
          data-testid={`${testId}-markAsRead`}
        />
      ) : (
        <Button
          variant="ghostLink"
          size="small"
          leftIcon="communication/email"
          title={i18n.t('general.actions.markAsUnread')}
          onClick={() => readState.onMarkUnread(props.message)}
          data-testid={`${testId}-markAsUnread`}
        />
      )}
    </HStack>
  );
}
